var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isProfile)?_c('About'):_c('Home')}
var staticRenderFns = []

export { render, staticRenderFns }